import { createContext, useContext } from "react";
import { UNSAFE_RouteContext, useMatches } from "react-router-dom";
import { MatchInterface, RouterLinksInterface } from "./types";

//getMatchingChildLinks
export const useGetChildLinks = () => {
  const routeContexts = useContext(UNSAFE_RouteContext);
  return routeContexts.matches.sort((a, b) => a.pathname.length - b.pathname.length)[1].route.handle?.childLinks ?? [];
};

//getLinkById
const LinkContext = createContext<RouterLinksInterface>({});
export const LinkProvider = LinkContext.Provider;

export const useGetRouterLinkById = (linkId: string) => {
  const links = useContext(LinkContext);
  return links[linkId];
};

//getMainTitles
const useMFMatches = () => {
  return useMatches() as unknown as MatchInterface[];
};

export const useGetMainTitles = () => {
  const matches = useMFMatches();
  const titles = matches.find(({ id }) => id !== "0")?.handle?.label ?? "";
  return [titles];
};
